// extracted by mini-css-extract-plugin
var _1 = "ApplicantCreditCheckResult-moduleApplicantCreditCheckResult__QwHvp";
var _2 = "ApplicantCreditCheckResult-moduledocument__lEELd";
var _3 = "ApplicantCreditCheckResult-moduledocumentLabel__vNIV2 ApplicantCreditCheckBlock-moduledocumentLabel__bKVxW";
var _4 = "ApplicantCreditCheckResult-moduleline__UsyM0 ApplicantCreditCheckBlock-moduleline__iu1fZ";
var _5 = "ApplicantCreditCheckResult-moduleprovider__DQoUT";
var _6 = "ApplicantCreditCheckResult-moduleresultHead__OIXP2 ApplicantCreditCheckResult-moduleresultSpan__hUN4L";
var _7 = "ApplicantCreditCheckResult-moduleresultRows__eqV8i";
var _8 = "ApplicantCreditCheckResult-moduleresultSpan__hUN4L";
var _9 = "ApplicantCreditCheckResult-modulerowLabel__cDzhs";
var _a = "ApplicantCreditCheckResult-modulerowNote__Y5RBF ApplicantCreditCheckBlock-moduleline__iu1fZ";
export { _1 as "ApplicantCreditCheckResult", _2 as "document", _3 as "documentLabel", _4 as "line", _5 as "provider", _6 as "resultHead", _7 as "resultRows", _8 as "resultSpan", _9 as "rowLabel", _a as "rowNote" }
